<template>
  <div>
    <transition name="van-fade">
      <loading-box v-show="!loadingFinished"></loading-box>
    </transition>
    <transition name="van-fade">
      <div class="content-container" v-show="loadingFinished">
        <div class="main-bg">
          <div class="bg-box">
            <van-image class="top" fit="cover" :src="topImage" />
            <van-image
              class="center"
              :src="centerImage"
              style="width:100%;flex:1"
            />
            <van-image class="bottom" fit="cover" :src="bottomImage" />
          </div>
        </div>
        <div class="main-box">
          <div class="logo"></div>
          <div class="title">Blockchain Preservation</div>
          <div class="code"><span>Transaction ID：</span>{{ txId }}</div>
          <div class="line"></div>
          <div class="form-title">Records</div>
          <div class="form-item-box">
            <div class="label">Block No：</div>
            <div class="value">{{ blockInfo.blockNumber }}</div>
          </div>
          <div class="form-item-box">
            <div class="label">Block ID：</div>
            <div class="value">
              {{ blockInfo.blockID }}
            </div>
          </div>
          <div class="form-item-box">
            <div class="label">Timestamp：</div>
            <div class="value">{{ blockInfo.blockTimestamp }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { dateFormat } from "@/utils/index";
import LoadingBox from '@/components/Loading/index.vue'


const explorerUrl = "https://mainnet.vecha.in"

export default {
  components: {
    LoadingBox
  },
  data() {
    return {
      loadingFinished: false,
      landingComplete: false,
      txId: "",
      requestError: "",
      blockInfo: {
        blockID: "",
        blockNumber: "",
        blockTimestamp: ""
      },
      mainImage: require("@/assets/imgs/cert/cert_bg.png"),
      topImage: require("@/assets/imgs/cert/cert_bg_top.png"),
      centerImage: require("@/assets/imgs/cert/cert_bg_mid.png"),
      bottomImage: require("@/assets/imgs/cert/cert_bg_bot.png")
    };
  },
  created() {},
  mounted() {
    this.txId = this.$route.params.txId
    if (this.txId == "") {
      this.txId = this.$route.query.txId
    }
    if (this.txId != "") {
      this.getBlock(this.txId);
    }
  },
  methods: {
    getBlock(txId) {
      let baseUrl = explorerUrl + "/transactions/" + txId;

      this.$axios
        .get(baseUrl, {})
        .then(res => {
          let data = res.data.meta;
          this.blockInfo = {
            blockID: data.blockID,
            blockNumber: data.blockNumber,
            blockTimestamp: dateFormat(
              data.blockTimestamp * 1000,
              "yyyy-MM-dd hh:mm:ss"
            ),
          };
          this.landingComplete = true;
          setTimeout(() => {
            this.loadingFinished = true;
          }, 300);
        })
        .catch(err => {});
    },
  }
};
</script>

<style lang="scss" scoped>
.content-container {
  position: relative;
  padding: 15px;
  .main-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    .bg-box {
      display: flex;
      flex-direction: column;
      padding: 15px;
      height: 100%;
      .top,
      .bottom,
      .center {
        width: 100%;
      }
      .center {
        flex: 1;
      }
    }
  }
  .main-box {
    position: relative;
    margin: 30px 35px;
    padding-bottom: 50px;
    .logo {
      width: 100px;
      height: 100px;
      margin: 60px auto 25px;
      background: url("~@/assets/imgs/cert/cert_logo.png") center center
        no-repeat;
      background-size: cover;
    }
    .title {
      width: 184px;
      height: 24px;
      margin: 0 auto 16px;
      font-weight: 900;
      text-align: left;
    }
    .code {
      text-align: center;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      color: #5096ff;
      word-wrap: break-word;
    }
    .line {
      height: 5px;
      margin: 23px 0;
      background: url("~@/assets/imgs/cert/cert_line.png") center center
        no-repeat;
      background-size: cover;
    }
    .info-box {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #7f7f7f;
      text-align: left;
      margin-bottom: 20px;
      .item {
        display: flex;
        margin-bottom: 2px;
        line-height: 22px;
        &:last-child {
          margin-bottom: 0;
        }
        .label {
          width: 60px;
        }
        .value {
          flex: 1;
        }
      }
    }
    .form-title {
      width: 89px;
      height: 24px;
      margin-bottom: 16px;
      font-weight: 900;
      text-align: left;
    }
    .form-item-box {
      margin-bottom: 16px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 22px;
      text-align: left;
      .label {
        color: #7f7f7f;
        margin-bottom: 8px;
      }
      .value {
        color: #000000;
        background: #f4f7fe;
        padding: 10px 16px;
        word-wrap: break-word;
      }
    }
  }
}
</style>
